import { BarChart3 } from 'lucide-react';
import type { FC } from 'react';

interface Props {
  byPlan: Record<string, number> | undefined;
}

const PLAN_CFG: Record<string, { label: string; color: string; darkColor: string }> = {
  free: { label: 'Free', color: 'bg-slate-400', darkColor: 'dark:bg-slate-500' },
  pro: { label: 'Pro', color: 'bg-blue-500', darkColor: 'dark:bg-blue-400' },
  team: { label: 'Team', color: 'bg-purple-500', darkColor: 'dark:bg-purple-400' },
  business: { label: 'Business', color: 'bg-amber-500', darkColor: 'dark:bg-amber-400' },
  enterprise: { label: 'Enterprise', color: 'bg-emerald-500', darkColor: 'dark:bg-emerald-400' },
};

const PlanDistributionChart: FC<Props> = ({ byPlan }) => {
  const entries = Object.entries(byPlan ?? {}).sort((a, b) => b[1] - a[1]);
  const max = Math.max(...entries.map(([, v]) => v), 1);

  return (
    <div className="fc-card p-5">
      <div className="mb-4 flex items-center gap-2">
        <BarChart3 className="h-4 w-4 text-slate-500 dark:text-slate-400" />
        <h3 className="text-xs font-medium uppercase tracking-wider text-slate-500 dark:text-slate-400">
          Répartition par Plan
        </h3>
      </div>

      <div className="space-y-3">
        {entries.map(([plan, count]) => {
          const cfg = PLAN_CFG[plan] ?? { label: plan, color: 'bg-slate-400', darkColor: 'dark:bg-slate-500' };
          const pct = Math.round((count / max) * 100);
          return (
            <div key={plan}>
              <div className="mb-1 flex items-center justify-between">
                <span className="text-sm font-medium text-slate-700 dark:text-slate-300">{cfg.label}</span>
                <span className="text-sm font-bold text-slate-900 dark:text-white">{count}</span>
              </div>
              <div className="h-2.5 w-full overflow-hidden rounded-full bg-slate-100 dark:bg-slate-700">
                <div
                  className={`h-full rounded-full transition-all duration-500 ${cfg.color} ${cfg.darkColor}`}
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          );
        })}

        {entries.length === 0 && (
          <p className="py-4 text-center text-sm text-slate-400 dark:text-slate-500">
            Aucune donnée disponible
          </p>
        )}
      </div>
    </div>
  );
};

export default PlanDistributionChart;
